import FamilyAlbumDetailModule from './FamilyAlbumDetailModule'
export default FamilyAlbumDetailModule
